import { Document } from "@react-pdf/renderer";
import LoyaltyRebateInvoiceResponse from "@/app/interfaces/response/LoyaltyRebateInvoiceResponse";
import QualifyingInvoicePagePDF from "./QualifyingInvoicePagePdf";

const QualifyingInvoicesPDF = ({ invoices }: { invoices: LoyaltyRebateInvoiceResponse[] }) => {
  return (
    <Document>
      {invoices.map((invoice) => (
        <QualifyingInvoicePagePDF key={invoice.id} invoice={invoice} />
      ))}
    </Document>
  );
};

export default QualifyingInvoicesPDF;